const $ = require("jquery");
window.$ = window.jQuery = $;

const utils = require("../../../utils");

class OtherAreasMMH {
	constructor(reportId) {
		this.reportId = reportId;
		this.$container = $("<form class='other-areas-container'></form>");
		this.$parentContainer = $(
			"#div" + reportId + "_index .additional-info-form"
		);
		this.stateModel = {
			otherAreasMMH: []
		};
		this.state = JSON.parse(JSON.stringify(this.stateModel));

		this.containerHeadingBaseClass = "other-areas-heading";
		this.innerContainerBaseClass = "other-area-container";

		this.nameContainerBaseClass = "other-area-name-container";
		this.nameLabelBaseClass = "other-area-name-label";
		this.nameSelectBaseClass = "other-area-name-select";
		this.nameSelectName = "otherAreas_name";

		this.sqFtContainerBaseClass = "other-area-sqft-container";
		this.sqFtLabelBaseClass = "other-area-sqft-label";
		this.sqFtInputBaseClass = "other-area-sqft-input";
		this.sqFtInputName = "otherAreas_squareFootage";

		this.yearBuiltContainerBaseClass = "other-area-year-built-container";
		this.yearBuiltLabelBaseClass = "other-area-year-built-label";
		this.yearBuiltInputBaseClass = "other-area-year-built-input";
		this.yearBuiltInputName = "otherAreas_yearBuilt";

		this.addTriggerContainerBaseClass = "other-areas-add-trigger-container";
		this.addTriggerLinkBaseClass = "other-areas-add-trigger";

		this.removeTriggerBaseClass = "other-area-remove-trigger";
	}

	init() {
		this.createAddTrigger();
		this.createHeading();
		this.$container.appendTo(this.$parentContainer);
		this.createModel();
		this.attachAddTriggerClickListener();
	}

	createHeading() {
		this.$heading = $(
			"<p class='" + this.containerHeadingBaseClass + "'>Other Areas</p>"
		);
		this.$heading.hide();
		this.$heading.insertBefore(this.$addTriggerContainer);
	}

	createModel() {
		var $innerContainer = $(
			"<div class='" + this.innerContainerBaseClass + "'></div>"
		);

		var $removeTrigger = $(
			"<a href='#' title='Remove Area' class='" +
				this.removeTriggerBaseClass +
				"'><i class='icon-cancel'></i></a>"
		);

		var $nameContainer = $(
			"<div class='" + this.nameContainerBaseClass + "'></div>"
		);
		var $nameLabel = $(
			"<label class='" + this.nameLabelBaseClass + "'>Name: *</label>"
		);
		var $nameSelect = $(
			"<select class='" +
				this.nameSelectBaseClass +
				"' name='" +
				this.nameSelectName +
				"' required></select>"
		);

		$nameSelect.html(
			'<option value="1/2 story">1/2 story</option><option value="3/4 story">3/4 story</option><option value="attic, finished">attic, finished</option><option value="attic, unfinished">attic, unfinished</option><option value="balcony">balcony</option><option value="barn, attached">barn, attached</option><option value="basement, finished below grade">basement, finished below grade</option><option value="basement, finished walk out">basement, finished walk out</option><option value="basement, garden level">basement, garden level</option><option value="basement, partially finished">basement, partially finished</option><option value="basement, partially finished walk-out">basement, partially finished walk-out</option><option value="basement, unfinished">basement, unfinished</option><option value="basement, unfinished w/breakaway walls">basement, unfinished w/breakaway walls</option><option value="basement, unfinished walk-out">basement, unfinished walk-out</option><option value="bonus room">bonus room</option><option value="bowling alley">bowling alley</option><option value="breeze way">breeze way</option><option value="carport">carport</option><option value="cellar">cellar</option><option value="conservatory">conservatory</option><option value="crawl space">crawl space</option><option value="crawlspace w/breakaway walls">crawlspace w/breakaway walls</option><option value="deck, roof">deck, roof</option><option value="deck, specialty wood">deck, specialty wood</option><option value="deck, synthetic lumber">deck, synthetic lumber</option><option value="deck, wood">deck, wood</option><option value="English basement">English basement</option><option value="finished room over garage">finished room over garage</option><option value="garage, attached">garage, attached</option><option value="garage, basement">garage, basement</option><option value="garage, basement w/breakaway walls">garage, basement w/breakaway walls</option><option value="garage, built-in">garage, built-in</option><option value="garage, finished attached">garage, finished attached</option><option value="garage, finished basement">garage, finished basement</option><option value="garage, finished built-in">garage, finished built-in</option><option value="greenhouse">greenhouse</option><option value="half story">half story</option><option value="indoor basketball court">indoor basketball court</option><option value="indoor swimming pool">indoor swimming pool</option><option value="indoor tennis court">indoor tennis court</option><option value="lanai">lanai</option><option value="living area">living area</option><option value="living area, finished">living area, finished</option><option value="living area, unfinished">living area, unfinished</option><option value="lower level, finished">lower level, finished</option><option value="lower level, finished walk-out">lower level, finished walk-out</option><option value="lower level, partially finished">lower level, partially finished</option><option value="lower level, partially finished walk-out">lower level, partially finished walk-out</option><option value="lower level, unfinished">lower level, unfinished</option><option value="lower level, unfinished walk-out">lower level, unfinished walk-out</option><option value="other">other</option><option value="passageway">passageway</option><option value="patio, covered">patio, covered</option><option value="patio, covered/elevated">patio, covered/elevated</option><option value="patio, elevated">patio, elevated</option><option value="pergola">pergola</option><option value="porch, covered">porch, covered</option><option value="porch, enclosed">porch, enclosed</option><option value="porch, open">porch, open</option><option value="porch, screened">porch, screened</option><option value="porte cochere">porte cochere</option><option value="screened pool (screening only)">screened pool (screening only)</option><option value="solarium">solarium</option><option value="stable, attached">stable, attached</option><option value="stoop">stoop</option><option value="storage area w/breakaway walls">storage area w/breakaway walls</option><option value="storage area, above ground">storage area, above ground</option><option value="storage area, below ground">storage area, below ground</option><option value="swimming pool, outdoor attached">swimming pool, outdoor attached</option><option value="three-quarter story">three-quarter story</option><option value="tunnel">tunnel</option>'
		);

		var $sqFtContainer = $(
			"<div class='" + this.sqFtContainerBaseClass + "'></div>"
		);
		var $sqFtLabel = $(
			"<label class='" + this.sqFtLabelBaseClass + "'>Square Footage: *</label>"
		);
		var $sqFtInput = $(
			"<input class='" +
				this.sqFtInputBaseClass +
				"' type='number' name='" +
				this.sqFtInputName +
				"' required>"
		);

		var $yearBuiltContainer = $(
			"<div class='" + this.yearBuiltContainerBaseClass + "'></div>"
		);
		var $yearBuiltLabel = $(
			"<label class='" +
				this.yearBuiltLabelBaseClass +
				"'>Year Built: *</label>"
		);
		var $yearBuiltInput = $(
			"<input class='" +
				this.yearBuiltInputBaseClass +
				"' type='number' name='" +
				this.yearBuiltInputName +
				"' required>"
		);

		$removeTrigger.appendTo($innerContainer);

		$nameLabel.appendTo($nameContainer);
		$nameSelect.appendTo($nameContainer);

		$sqFtLabel.appendTo($sqFtContainer);
		$sqFtInput.appendTo($sqFtContainer);

		$yearBuiltLabel.appendTo($yearBuiltContainer);
		$yearBuiltInput.appendTo($yearBuiltContainer);

		$nameContainer.appendTo($innerContainer);
		$sqFtContainer.appendTo($innerContainer);
		$yearBuiltContainer.appendTo($innerContainer);

		this.$elModel = $innerContainer;
	}

	createAddTrigger() {
		this.$addTriggerContainer = $(
			"<div class='" + this.addTriggerContainerBaseClass + "'></div>"
		);
		this.hideAddTrigger();

		this.$addTrigger = $(
			"<a href='#' class='" +
				this.addTriggerLinkBaseClass +
				"'><i class='icon-plus'></i>Add Other Areas</a>"
		);
		this.$addTrigger.appendTo(this.$addTriggerContainer);
		this.$addTriggerContainer.appendTo(this.$parentContainer);

		this.showAddTrigger();
	}

	hideAddTrigger() {
		this.$addTriggerContainer.hide();
	}

	showAddTrigger() {
		if (Object.keys(window.reportsModel) <= 0) {
			if (
				utils.getReportParameterByName(
					window.reportConfigurationModel,
					"replacementCost",
					"allowOtherAreasOnFirstRun"
				) === true
			) {
				this.$addTriggerContainer.show();
			} else if (
				utils.getReportParameterByName(
					window.reportConfigurationModel,
					"replacementCostMobileManufacturedHomes",
					"allowOtherAreasOnFirstRun"
				) === true
			) {
				this.$addTriggerContainer.show();
			}
		} else {
			this.$addTriggerContainer.show();
		}
	}

	attachAddTriggerClickListener() {
		let self = this;

		this.$addTrigger.on("click", function (e) {
			e.preventDefault();
			self.add();
		});
	}

	add(inputs) {
		var $el = this.$elModel.clone().insertBefore(this.$addTriggerContainer);
		this.$heading.show();
		this.attachRemoveTriggerClickListener($el);

		$("." + this.innerContainerBaseClass).each(function (index) {
			$(this)
				.find("select, input, textarea")
				.each(function () {
					$(this).attr("id", $(this).attr("name") + "_" + index);
				});
		});

		for (var input in inputs) {
			$el.find('*[name="otherAreas_' + input + '"]').val(inputs[input]);
		}
	}

	attachRemoveTriggerClickListener($el) {
		let self = this;

		$el.find("." + this.removeTriggerBaseClass).on("click", function (e) {
			e.preventDefault();
			self.remove($el);
		});
	}

	remove($el) {
		$el.remove();

		if ($("." + this.innerContainerBaseClass).length <= 0) {
			this.$heading.hide();
		}
	}

	removeAll() {
		let self = this;

		$("." + this.innerContainerBaseClass).each(function () {
			self.remove($(this));
		});
	}
}

module.exports = OtherAreasMMH;
